import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import ProjectsModal from "~/components/project/ProjectsModal";
import CreateTaskModal from "~/components/tasks/CreateTaskModal";
import { CreateTaskContextProvider } from "./context";

const CreateTaskProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    projectId: 0,
    presetNoAssignee: false,
    assigneeId: 0,
    dueOn: null,
  });

  const [modalOpenFrom, setModalOpenFrom] = useState();

  const openModal = useCallback((params = {}) => {
    const { projectId = 0, presetNoAssignee = false, assigneeId = 0, dueOn = null } = params;
    setState({ open: true, projectId, presetNoAssignee, assigneeId, dueOn });
  }, []);

  const handleCloseProjectsModal = useCallback(() => {
    setState((prevState) => {
      if (prevState.projectId > 0) {
        return prevState;
      }
      return {
        open: false,
        projectId: 0,
        presetNoAssignee: false,
        assigneeId: 0,
        dueOn: null,
      };
    });
    setModalOpenFrom(null);
  }, []);

  const handleCloseTaskModal = useCallback(() => {
    setState({
      open: false,
      projectId: 0,
      presetNoAssignee: false,
      assigneeId: 0,
      dueOn: null,
    });
    setModalOpenFrom(null);
  }, []);
  const handleChooseProject = useCallback((projectId) => {
    setState((prevState) => ({ ...prevState, projectId }));
    setModalOpenFrom(null);
  }, []);

  return (
    <CreateTaskContextProvider value={{ openModal, modalOpenFrom, setModalOpenFrom }}>
      {children}
      <ProjectsModal
        open={state.open && state.projectId === 0}
        onClose={handleCloseProjectsModal}
        onChooseProject={handleChooseProject}
      />
      <CreateTaskModal
        open={state.open && state.projectId > 0}
        onClose={handleCloseTaskModal}
        projectId={state.projectId}
        presetNoAssignee={state.presetNoAssignee}
        presetAssigneeId={state.assigneeId}
        dueOn={state.dueOn}
      />
    </CreateTaskContextProvider>
  );
};

CreateTaskProvider.propTypes = {
  children: PropTypes.any,
};

export default CreateTaskProvider;
